import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { BrowserRouter } from "react-router-dom";
// import { BrowserRouter, Route } from "react-router-dom";
import { AppGridWrap, AppContainer, RouteBox } from "./style";
import Header from "../Header";
import SideBar, { MenuList, ShortcutManual } from "../SideBar";
import AppRouter from "../../router/Routes";
import { getServerType } from "../../constants";
import AddOn from "../SideBar/AddOn";
import PrivateRoute from "../../router/PrivateRoute";
import { checkAuth, signOut } from "../../utils/nauth";
import { getTemplateCount } from "../../api/Common";
import { useCookies } from "react-cookie";
import { KEYWORD_COOKIES } from "../../store/KeywordsStore";

// const multiRoute = ({ paths, element: Element, ...rest }: any) =>
//   paths.map((path: string) => {
//     return <Route key={path} path={path} {...rest} element={Element} />;
//   });

const AppView = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [preparing, setPreparing] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies();
  // eslint-disable-next-line
  useEffect(() => {
    setIsLogin(checkAuth());
    getTemplateCount({}).then((response) => {
      setPreparing(response.totalCount);
    });
    // eslint-disable-next-line
  }, []);
  const headerClickHandler = () => {
    removeCookie("page", { path: "/" });
    removeCookie("startDate", { path: "/" });
    removeCookie("endDate", { path: "/" });
    removeCookie("application", { path: "/" });
    removeCookie("status", { path: "/" });
    removeCookie("language", { path: "/" });
    removeCookie("category", { path: "/" });
    removeCookie("mixability", { path: "/" });
    removeCookie("reference", { path: "/" });
    removeCookie("asset", { path: "/" });
    removeCookie("entertainment", { path: "/" });
    removeCookie("ratio", { path: "/" });

    removeCookie("mPage", { path: "/" });
    removeCookie("mStartDate", { path: "/" });
    removeCookie("mEndDate", { path: "/" });
    removeCookie("mApplication", { path: "/" });
    removeCookie("mStatus", { path: "/" });
    removeCookie("mLanguage", { path: "/" });
    removeCookie("mCategory", { path: "/" });
    removeCookie("mMixability", { path: "/" });
    removeCookie("mReference", { path: "/" });
    removeCookie("mAsset", { path: "/" });
    removeCookie("mEntertainment", { path: "/" });
    removeCookie("mRatio", { path: "/" });

    removeCookie("hPage", { path: "/" });
    removeCookie("hStartDate", { path: "/" });

    removeCookie("ai_page", { path: "/" });
    removeCookie("ai_rowsPerPage", { path: "/" });
    removeCookie("ai_startDate", { path: "/" });
    removeCookie("ai_endDate", { path: "/" });
    removeCookie("ai_application", { path: "/" });
    removeCookie("ai_status", { path: "/" });
    removeCookie("ai_language", { path: "/" });
    removeCookie("ai_category", { path: "/" });
    removeCookie("ai_tSort", { path: "/" });
    removeCookie("ai_sortKey", { path: "/" });
    // legacy cookies from earlier AI Review iterations
    removeCookie("ai_mixability", { path: "/" });
    removeCookie("ai_reference", { path: "/" });
    removeCookie("ai_asset", { path: "/" });
    removeCookie("ai_entertainment", { path: "/" });
    removeCookie("ai_ratio", { path: "/" });
    removeCookie("ai_modFilter", { path: "/" });
    removeCookie("ai_ageFilter", { path: "/" });
    removeCookie("ai_qScoreMin", { path: "/" });
    removeCookie("ai_qScoreMax", { path: "/" });

    KEYWORD_COOKIES.forEach((name) => removeCookie(name, { path: "/" }));

    window.location.href = "/";
  };

  return (
    <BrowserRouter>
      <AppGridWrap>
        <Header
          label="KineMaster Console :: Template"
          server={getServerType()}
          isLogin={isLogin}
          logoutHandler={signOut}
          onClick={headerClickHandler}
        />
        <AppContainer>
          <SideBar menuList={MenuList}>
            <AddOn count={preparing} />
            <br />
            <br />
            <br />
            <ShortcutManual />
          </SideBar>

          <RouteBox>
            <PrivateRoute>
              <AppRouter />
            </PrivateRoute>
          </RouteBox>
        </AppContainer>
      </AppGridWrap>
    </BrowserRouter>
  );
};

export default observer(AppView);
